import { LoggedInSubAccount } from './types';

export function isSubAccount(obj: any): obj is LoggedInSubAccount {
  return Boolean(obj) && 'isSubAccount' in obj && Boolean(obj.isSubAccount);
}
